export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Facility\",\n    \"label_other\": \"{{count}} Facilities\"\n}\n"